import axios from "axios"

const liveApiUrl = process.env.REACT_APP_LIVE_API_URL


export const getTeacherLessonPlanApi = async () => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("Token"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    return await axios.get(
      `${liveApiUrl}/api/classwork/teacher/get-lessonplan`,
      {
        headers,
      }
    )
  } catch (error) {
    console.error("Error Gettting teacher lesson plans:", error)
    throw error
  }
}


export const addNewLessonPlanApi = async (payload) => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("Token"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    return await axios.post(
      `${liveApiUrl}/api/classwork/create-lessonplan`,
      payload,
      {
        headers,
      }
    )

  } catch (error) {
    console.error("Error Gettting teacher lesson plans:", error)
    throw error
  }
}


export const updateLessonPlanApi = async (payload) => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("Token"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    return await axios.post(
      `${liveApiUrl}/api/classwork/update-lessonplan`,
      payload,
      {
        headers,
      }
    )

  } catch (error) {
    console.error("Error Gettting teacher lesson plans:", error)
    throw error
  }
}


export const getStudLessonPlanApi = async (payload) => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("Token"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    return await axios.post(
      `${liveApiUrl}/api/classwork/parents/get-lessonplan`,
      payload,
      {
        headers,
      }
    )
  } catch (error) {
    console.error("Error Gettting Student lesson plans:", error)
    throw error
  }
}



export const getAdminLessonPlanApi = async () => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("Token"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    return await axios.get(
      `${liveApiUrl}/api/classwork/admin/get-lessonplan`,
      {
        headers,
      }
    )
  } catch (error) {
    console.error("Error Gettting Admin lesson plans:", error)
    throw error
  }
}